import React from 'react';
import { TextField } from '../../../../components/TextField';

export const ContentInput = ({
  title,
  value,
  handleValue,
}) => {
  return (
    <div>
      {title}
      <TextField
        value={value}
        onChange={handleValue}
      />
    </div>
  );
};
